import axios from 'axios'
import { getLocalStorageWithExpiry } from '@/utils/index.js';
import { MessageBox } from 'element-ui';

const instance = axios.create({
	baseURL: '/stage-api/',
	timeout: 15000,
	headers: {
		'X-Custom-Header': 'foobar'
	}
});

const instanceRabbitmq = axios.create({
	baseURL: '/rabbitmq/',
	timeout: 15000,
	headers: {
		'X-Custom-Header': 'foobar'
	}
});

const instanceTunnelDevApi = axios.create({
	baseURL: '/tunnelDev-api/',
	timeout: 15000,
	headers: {
		'X-Custom-Header': 'foobar'
	}
});

const instanceCapsRundePro = axios.create({
	baseURL: '/apiCapsRundePro/',
	// baseURL: 'https://caps.runde.pro/api/',
	timeout: 15000,
	headers: {
		'X-Custom-Header': 'foobar'
	}
});

// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        const token = getLocalStorageWithExpiry('updateToken'); // localStorage.getItem('updateToken');
        if (token) {
            config.headers['lg-authorization'] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// https: //console-mock.apipost.cn/mock/ba93600f-49f0-474d-98e1-cc92cf6ed468?
export const getApi = (url) => {
	const data = new Promise((resolve) => {
		instance.get(url)
		.then(function(response) {
			console.log(response);
			if(response.data.code === 401){
				console.log(url,response)
				MessageBox.alert('登录过期，或已在其他地方登录，请重新登录', '系统提示', {
				confirmButtonText: '确定',
				callback: action => {
					window.location.href = '/login';
				}
				});
			}
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}
export const postApi = (url, params) => {
	const data = new Promise((resolve) => {
		instance.post(url, params)
		.then(function(response) {
			
			if(response.data.code === 401){
				console.log(url,response,params)
				MessageBox.alert('登录过期，或已在其他地方登录，请重新登录', '系统提示', {
				confirmButtonText: '确定',
				callback: action => {
					window.location.href = '/login';
				}
				});
			}
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}

export const getApiCapsRundePro = (url) => {
	const data = new Promise((resolve) => {
		instanceCapsRundePro.get(url)
		.then(function(response) {
			// console.log(response);
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}

export const postApiCapsRundePro = (url, params) => {
	const data = new Promise((resolve) => {
		instanceCapsRundePro.post(url, params)
		.then(function(response) {
			// console.log(response);
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}

export const postApiCapsRabbitmq = (url, params) => {
	const data = new Promise((resolve) => {
		instanceRabbitmq.post(url, params)
		.then(function(response) {
			// console.log(response);
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}

export const postApiCapsTunnelDevApi = (url, params) => {
	const data = new Promise((resolve) => {
		instanceTunnelDevApi.post(url, params)
		.then(function(response) {
			// console.log(response);
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}


export const getApiCapsTunnelDevApi = (url) => {
	const data = new Promise((resolve) => {
		instanceTunnelDevApi.get(url)
		.then(function(response) {
			// console.log(response);
			resolve(response)
		})
		.catch(function(error) {
			console.log(error);
		});
	})
	return data
}